import styled, {css} from 'styled-components';

export const TextareaContainer = styled.div`
position: relative;
padding-top: 14px;

textarea:focus ~ .floating-label,
textarea:not(:focus):valid ~ .floating-label,
textarea:disabled ~ .floating-label{
  top: 0px;
  left: 0px;
  font-size: 11px;
  opacity: 1;
}

.floating-label {
  position: absolute;
  pointer-events: none;
  left: 0px;
  top: 20px;
  transition: 0.2s;
  font-size: 1rem;
  line-height: 1;
  font-weight: 500;
}
`;

export const FloatingLabel = styled.span`
${({ error }) => css`
  color: ${error ? '#e6422e' : '#0000008a'};
`}
`;

export const Textarea = styled.textarea`
${({ error }) => css`
  font-family: AASmartSans, Arial;
  width: 100%;
  max-width: 100%;
  border: 0px;
  border-bottom: ${error ? '2px solid #e6422e' : '2px solid #949494'};
  background-color: transparent;
  
  :focus-visible {
    border: 0px;
    border-bottom: ${error ? '2px solid #e6422e' : '2px solid #949494'};
    outline: 0;
  }

  :disabled {
    border-bottom-style: dotted;
    border-bottom-color: #0000006b;
    border-bottom-width: 1px;
    color: #0000006b;
  }
`}
`;